var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "5 5.07 90 89.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m41.723 34.051h16.559c1.9883 0 3.6016 1.6133 3.6016 3.6016v53.68c0 1.9883-1.6133 3.6016-3.6016 3.6016l-16.559-0.003906c-1.9883 0-3.6016-1.6133-3.6016-3.6016v-53.68c0-1.9883 1.6133-3.5977 3.6016-3.5977zm12.957 7.1992h-9.3594v46.48h9.3594zm20.16-36.18h16.559c1.9883 0 3.6016 1.6133 3.6016 3.6016v82.656c0 1.9883-1.6133 3.6016-3.6016 3.6016h-16.559c-1.9883 0-3.6016-1.6133-3.6016-3.6016v-82.656c0-1.9883 1.6133-3.6016 3.6016-3.6016zm12.957 7.1992h-9.3594v75.457h9.3594zm-79.195 50.758h16.559c1.9883 0 3.6016 1.6133 3.6016 3.6016v24.699c0 1.9883-1.6133 3.6016-3.6016 3.6016h-16.559c-1.9883 0-3.6016-1.6133-3.6016-3.6016l0.003906-24.699c0-1.9883 1.6094-3.6016 3.5977-3.6016zm12.961 7.1992h-9.3594v17.5h9.3594z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGraph);
export default __webpack_public_path__ + "static/media/icon-graph.f22c612a2616a12ad7e8726aef3a364f.svg";
export { ForwardRef as ReactComponent };